import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import { claimsAPI } from '../services/api';

const Claims = () => {
  const [claims, setClaims] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadClaims();
  }, []);

  const loadClaims = async () => {
    try {
      const response = await claimsAPI.getAll();
      setClaims(response.data);
    } catch (error) {
      console.error('Error loading claims:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Layout><div>Loading...</div></Layout>;

  return (
    <Layout>
      <h2 style={{ marginBottom: '1.5rem' }}>My Claims</h2>
      {claims.length === 0 ? (
        <div style={{ background: 'white', padding: '2rem', borderRadius: '8px', border: '1px solid #ddd', textAlign: 'center' }}>
          <p>No claims found.</p>
        </div>
      ) : (
        <div style={{ background: 'white', borderRadius: '8px', overflow: 'hidden', border: '1px solid #ddd' }}>
          {claims.map((claim) => (
            <div key={claim.id} style={{ padding: '1rem', borderBottom: '1px solid #ddd' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1rem' }}>
                <div style={{ flex: '1 1 auto', minWidth: '200px' }}>
                  <h3 style={{ margin: '0 0 0.5rem 0', fontSize: 'clamp(1rem, 3vw, 1.1rem)' }}>{claim.claim_reference}</h3>
                  <p style={{ margin: '0.25rem 0', color: '#666', fontSize: 'clamp(0.85rem, 2vw, 1rem)' }}>Status: <strong>{claim.client_status || claim.status}</strong></p>
                  <p style={{ margin: '0.25rem 0', fontSize: 'clamp(0.8rem, 2vw, 0.9rem)', color: '#888' }}>
                    Last updated: {new Date(claim.last_updated).toLocaleDateString()}
                  </p>
                </div>
                <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', flex: '0 1 auto', minWidth: '200px' }}>
                  <Link to={`/claims/${claim.claim_reference}`} style={{ flex: '1 1 auto', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '0.5rem 1rem', background: '#2c3e50', color: 'white', textDecoration: 'none', borderRadius: '4px', whiteSpace: 'nowrap', fontSize: 'clamp(0.85rem, 2vw, 1rem)' }}>
                    View Details
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </Layout>
  );
};

export default Claims;
